import React, { useEffect, useState } from "react";
import { fetchToken } from "../../../features/common/FetchCookie";
import HomeLoggedIn from "./HomeLoggedIn";
import { Home } from "./Home";

const HomePage = () => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const fetchingToken = async () => {
      const token = await fetchToken();
      if (token) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    };
    fetchingToken();
  }, []);

  return <div>{isLogin ? <HomeLoggedIn /> : <Home />}</div>
};

export default HomePage;
